import { cn } from '@utils/index'
import Image from 'next/image'

export type LoadingSpinnerProps = {
  size?: number
  className?: string
}

const LoadingSpinner = ({ size = 20, className }: LoadingSpinnerProps) => {
  return (
    <div className={cn('flex w-screen items-center justify-center', className)}>
      <div className="rounded-full overflow-hidden h-fit w-fit p-4 bg-[#26333e] animate-spin">
        <Image
          className="scale-x-[-1]"
          alt="loading-spinner"
          src="/assets/loadingSpinner.png"
          width={size}
          height={size}
        />
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  )
}

export default LoadingSpinner
